export default __webpack_public_path__ + "static/media/PaginaWeb.2764bbeb.svg";